module.exports = __webpack_public_path__ + "img/partner24.32583f71.png";